export default {"src":"/_next/static/media/ship-play-dark.fae38437.svg","height":40,"width":170,"blurWidth":0,"blurHeight":0};